<ng-template #content>
  <ng-content></ng-content>
</ng-template>
@if (interaction.uriLocationType === UriLocationType.External) {
  <a [href]="uri" (click)="performPostNavigateCallback()" [target]="interaction.target" [attr.data-user-flow-id]="userFlowId">
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </a>
}
@if (interaction.uriLocationType !== UriLocationType.External) {
  <a
    [routerLink]="uri"
    routerLinkActive="navigate_interaction--route-active"
    [ngClass]="{ 'navigate_interaction--active': (((renderingOptions | subscribe) || {})).forcedActive }"
    [routerLinkActiveOptions]="(((renderingOptions | subscribe) || {}).linkActiveOptions) || {}"
    [queryParams]="interaction.queryParams"
    [target]="interaction.target"
    [attr.data-user-flow-id]="userFlowId">
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </a>
}
